export const ListQueryKey = 'ltSendRecords';
export const DetailQueryKey = 'ltSendRecord';

export const Urls = {
  selectUrl: '/ltRegistrationRecord/list',
  updateUrl: '/ltRegistrationRecord/update',
};
